module.exports = [
    {
        "name": "中文",
        "lang": "zh"
    },
    {
        "name": "丹麦语",
        "lang": "da"
    },
    {
        "name": "乌克兰语",
        "lang": "uk"
    },
    {
        "name": "俄语",
        "lang": "ru"
    },
    {
        "name": "保加利亚语",
        "lang": "bg"
    },
    {
        "name": "克罗地亚语",
        "lang": "hr"
    },
    {
        "name": "冰岛语",
        "lang": "is"
    },
    {
        "name": "加泰罗尼亚语",
        "lang": "ca"
    },
    {
        "name": "匈牙利语",
        "lang": "hu"
    },
    {
        "name": "南非荷兰语",
        "lang": "af"
    },
    {
        "name": "印地语",
        "lang": "hi"
    },
    {
        "name": "印度尼西亚语",
        "lang": "in"
    },
    {
        "name": "土耳其语",
        "lang": "tr"
    },
    {
        "name": "塞尔维亚语",
        "lang": "sr"
    },
    {
        "name": "希伯来语",
        "lang": "he"
    },
    {
        "name": "希腊语",
        "lang": "el"
    },
    {
        "name": "德语",
        "lang": "de"
    },
    {
        "name": "意大利语",
        "lang": "it"
    },
    {
        "name": "拉脱维亚语",
        "lang": "lv"
    },
    {
        "name": "挪威语",
        "lang": "no"
    },
    {
        "name": "捷克语",
        "lang": "cs"
    },
    {
        "name": "斯洛伐克语",
        "lang": "sk"
    },
    {
        "name": "斯洛文尼亚语",
        "lang": "sl"
    },
    {
        "name": "斯瓦希里语",
        "lang": "sw"
    },
    {
        "name": "日语",
        "lang": "ja"
    },
    {
        "name": "法语",
        "lang": "fr"
    },
    {
        "name": "波兰语",
        "lang": "pl"
    },
    {
        "name": "泰语",
        "lang": "th"
    },
    {
        "name": "爱沙尼亚语",
        "lang": "et"
    },
    {
        "name": "瑞典语",
        "lang": "sv"
    },
    {
        "name": "祖鲁语",
        "lang": "zu"
    },
    {
        "name": "立陶宛语",
        "lang": "lt"
    },
    {
        "name": "罗马尼亚语",
        "lang": "ro"
    },
    {
        "name": "芬兰语",
        "lang": "fi"
    },
    {
        "name": "英语",
        "lang": "en"
    },
    {
        "name": "荷兰语",
        "lang": "nl"
    },
    {
        "name": "菲律宾语",
        "lang": "fil"
    },
    {
        "name": "葡萄牙语",
        "lang": "pt"
    },
    {
        "name": "西班牙语",
        "lang": "es"
    },
    {
        "name": "越南语",
        "lang": "vi"
    },
    {
        "name": "阿姆哈拉语",
        "lang": "am"
    },
    {
        "name": "韩语",
        "lang": "ko"
    },
    {
        "name": "马来语",
        "lang": "ms"
    }
]
